/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface PromoteResultView {
  job_candidate_id: string;
  status: string;
  email?: string | null;
  reasons?: string[];
}
